// src/components/Org/chart/BoxStaffCard.js
import { buildFallbackAvatar } from "../../../utils/AvatarFallback.js";

const BoxStaffCard = ({ data, level, addon = {} }) => {
  let { class: extraClass = "", css = "" } = addon;
  const staffId = data.idu ?? "unknown";

  // CASE 1: มีรูป → ใช้รูป
  // CASE 2: ไม่มีรูป → fallbackAvatar
  const fallback = buildFallbackAvatar(data.full_name, {
    size: 62,
    fontSize: 20 });
  const userPhoto =
    data.photo && data.photo !== ""
      ? `
        <div class="image-circle image-loader staff-photo-${staffId}" 
             id="staff-photo-${staffId}" 
             data-src="${data.photo}">
          ${fallback}
        </div>`
      : `<div class="image-circle no-photo">${fallback}</div>`;

  if (data?.class_code && data.class_code !== "") {
    extraClass += ` class-${data.class_code}`;
  }

  const classNames = [
    "staff",
    "card",
    `staff-${staffId}`,
    `level-${level}`,
    data.class_code ? `class-${data.class_code}` : "",
    extraClass,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    `<div key="${staffId}" id="staff-${staffId}" class="${classNames}" style="${css}">` +
    `<div class="photo">${userPhoto}</div>` +
    `<div class="detail">` +
    `<span class="position truncate">${data.position}</span>` +
    `<span class="full-name truncate">${data.full_name}</span>` +
    `</div>` +
    `</div>`
  );
};

export default BoxStaffCard;

